import { useCallback } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import {
  flowCardConditionsStore,
  type FlowCardConditionsStoreState,
} from './FlowCardConditionsStore.ts';
import { selectData, selectById, selectIsLoading } from '../selectors.ts';

import { useAttach } from '../useAttach.js';

export function useFlowCardConditionsData() {
  useAttach(flowCardConditionsStore, 'useFlowCardConditionsData');
  return useStoreWithEqualityFn(flowCardConditionsStore.store, selectData, shallow);
}
useFlowCardConditionsData.store = flowCardConditionsStore;

export function useFlowCardConditionsById() {
  useAttach(flowCardConditionsStore, 'useFlowCardConditionsById');
  return useStoreWithEqualityFn(flowCardConditionsStore.store, selectById, shallow);
}
useFlowCardConditionsById.store = flowCardConditionsStore;

export function useFlowCardCondition({ flowCardConditionId }: { flowCardConditionId: string }) {
  useAttach(flowCardConditionsStore, 'useFlowCardCondition');

  const select = useCallback(
    (state: FlowCardConditionsStoreState) => {
      return {
        flowCardCondition: state.byId?.[flowCardConditionId] ?? null,
        flowCardConditionInstance: state.data?.[flowCardConditionId] ?? null,
        isLoading: state.isLoading,
        error: state.error,
      };
    },
    [flowCardConditionId]
  );

  return useStoreWithEqualityFn(flowCardConditionsStore.store, select, shallow);
}
useFlowCardCondition.store = flowCardConditionsStore;

export function useFlowCardConditionsAttach() {
  useAttach(flowCardConditionsStore, 'useFlowCardConditionsAttach');
}
useFlowCardConditionsAttach.store = flowCardConditionsStore;

export function useFlowCardConditionsLoading() {
  useAttach(flowCardConditionsStore, 'useFlowCardConditionsLoading');
  return useStoreWithEqualityFn(flowCardConditionsStore.store, selectIsLoading, Object.is);
}
useFlowCardConditionsLoading.store = flowCardConditionsStore;
